import { render, staticRenderFns } from "./FormulaTable.vue?vue&type=template&id=1fd65c4b&scoped=true&"
import script from "./FormulaTable.vue?vue&type=script&lang=js&"
export * from "./FormulaTable.vue?vue&type=script&lang=js&"
import style0 from "./FormulaTable.vue?vue&type=style&index=0&id=1fd65c4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd65c4b",
  null
  
)

export default component.exports